// Presentation receipts only. Never delete booking recovery operations or infer
// settlement from these records. sessionStorage survives a WebView refresh.
const STORAGE_KEY = 'members-checkout-return-ui:v1'
const memory = new Map()

function keyFor(path) {
  const url = new URL(path, 'https://members.privana.club')
  url.searchParams.sort()
  return url.pathname + url.search
}

function read(path) {
  const key = keyFor(path)
  try { return JSON.parse(sessionStorage.getItem(STORAGE_KEY) || '{}')[key] || memory.get(key) } catch { return memory.get(key) }
}

function write(path, patch) {
  const key = keyFor(path)
  const next = { ...read(path), ...patch }
  memory.set(key, next)
  try {
    const receipts = JSON.parse(sessionStorage.getItem(STORAGE_KEY) || '{}')
    receipts[key] = next
    sessionStorage.setItem(STORAGE_KEY, JSON.stringify(receipts))
  } catch { /* The in-memory guard still prevents duplicate callbacks. */ }
}

export function claimCheckoutReturn(path) {
  if (read(path)?.received) return false
  write(path, { received: true })
  return true
}

export function dismissCheckoutReturn(path, destination) {
  write(path, { received: true, destination })
}

export function dismissedCheckoutDestination(path) { return read(path)?.destination || null }

export function beginCheckoutReturnAttempt() {
  // Legacy cancellation URLs have no session ID. Permit a fresh cancellation
  // for a new user-initiated attempt, retaining receipts for completed sessions.
  const reset = receipts => {
    for (const key of Object.keys(receipts)) {
      if (!new URL(key, 'https://members.privana.club').searchParams.has('session_id')) delete receipts[key]
    }
    return receipts
  }
  for (const key of memory.keys()) if (!new URL(key, 'https://members.privana.club').searchParams.has('session_id')) memory.delete(key)
  try { sessionStorage.setItem(STORAGE_KEY, JSON.stringify(reset(JSON.parse(sessionStorage.getItem(STORAGE_KEY) || '{}')))) } catch {}
}
